import React from 'react'
import {
  AddressFields,
  AmountField,
  CompanyFields,
  DonationFormCaptcha,
  FakeButtons,
  GeneralError,
  HolderFields,
  HolderHeadline,
  MatchingFundBanner,
  PaymentMethodError,
  PaymentMethodSelection,
  SSLLogo,
  StripeCCFields,
  StripeSEPADebitFields,
  SubmitButton,
  Terms,
} from '../shared'
import { Debug } from '../debug'
import { Form } from 'formik'
import { FormProps } from 'donate/types'
import { ProhibitedNotice } from '../iframe/prohibited_notice'

// Attention: stripe fields have to be part of the DOM during submit. That's why both
// steps need to remain mounted in order for cc and sepa_debit to work correctly.
export const SkiForm = ({ display, config }: FormProps): JSX.Element => {
  if (config.donationsProhibited) return <ProhibitedNotice />

  return (
    <>
      <Form>
        <div className="donate-iframe-header">
          <div className="donate-iframe-headline">
            <p className="line1">{i18n.t('donate.iframe.headline')}</p>
          </div>
        </div>

        <div className="donate-iframe-content generic-popover-constraints">
          <div className="max-w-screen-xs mx-auto p-3">
            <h4>{i18n.t('donate.iframe.amount_headline')}</h4>

            <GeneralError />

            <fieldset className="iframe-donations-donation-amount">
              <AmountField />
            </fieldset>

            <PaymentMethodSelection />

            <MatchingFundBanner config={config} display={display} />
            <HolderHeadline />
            <HolderFields />
            <CompanyFields />
            <AddressFields required />

            <StripeCCFields />
            <StripeSEPADebitFields />
            <PaymentMethodError />

            <p>
              Unser Partner betterplace.org wickelt die Spende ab. Wir übernehmen die Bankgebühren! Für Sie entstehen
              keine Kosten.
            </p>

            <div className="my-3 mt-6 flex justify-between items-center">
              <SubmitButton config={config} />
              <SSLLogo className="h-16" />
            </div>
            <Terms />
            <DonationFormCaptcha config={config} />
          </div>
        </div>
      </Form>
      <Debug />
    </>
  )
}
